// @gridLogTypeId int,
// @ownerAsiakasId int,
// @entryByPersonId int,
// @yyyymmdd int,
// @keikkaId int,
// @oldKeikkaId int,
// @newKeikkaId int,
// @vehicleId int,
// @oldVehicleId int,
// @newVehicleId int,
// @personId int,
// @oldPersonId int,
// @newPersonId int,
// @selite nvarchar(200),
// @comments nvarchar(200)

export default class gridLogClass {
  constructor(
    gridLogTypeId,
    ownerAsiakasId,
    entryByPersonId,
    yyyymmdd,
    keikkaId,
    oldKeikkaId,
    newKeikkaId,
    vehicleId,
    oldVehicleId,
    newVehicleId,
    personId,
    oldPersonId,
    newPersonId,
    selite,
    comments
  ) {
    this.gridLogTypeId = gridLogTypeId;
    this.ownerAsiakasId = ownerAsiakasId;
    this.entryByPersonId = entryByPersonId;
    this.yyyymmdd = yyyymmdd;
    this.keikkaId = keikkaId;
    this.oldKeikkaId = oldKeikkaId;
    this.newKeikkaId = newKeikkaId;
    this.vehicleId = vehicleId;
    this.oldVehicleId = oldVehicleId;
    this.newVehicleId = newVehicleId;
    this.personId = personId;
    this.oldPersonId = oldPersonId;
    this.newPersonId = newPersonId;
    this.selite = selite;
    this.comments = comments;
  }
}
